import { useState } from 'react'
import { readConsent, saveConsent, type CookieConsent as Consent } from '../lib/measurement'
import './CookieConsent.css'

export function CookieConsent() {
  const [open, setOpen] = useState(() => !readConsent())
  const [customizing, setCustomizing] = useState(false)
  const [choice, setChoice] = useState<Consent>(() => readConsent() ?? { analytics: false, advertising: false })
  function save(consent: Consent) { saveConsent(consent); setChoice(consent); setOpen(false) }
  return <>
    {open && <section className="cookie-consent" aria-label="Preferências de cookies">
      <div className="cookie-consent__message">
        <h2>Melhorando sua experiência no site</h2>
        <p>Usamos cookies para entender como você utiliza o site e as páginas que visita. Cookies analíticos e de publicidade só são ativados com sua autorização. <a href="/privacidade">Leia nossa Política de Privacidade</a>.</p>
      </div>
      {customizing && <fieldset><legend>Escolha os cookies opcionais</legend>
        <label><input type="checkbox" checked={choice.analytics} onChange={event => setChoice({ ...choice, analytics: event.target.checked })} /> Analíticos</label>
        <label><input type="checkbox" checked={choice.advertising} onChange={event => setChoice({ ...choice, advertising: event.target.checked })} /> Publicidade</label>
      </fieldset>}
      <div className="cookie-actions">
        <button type="button" className="cookie-actions__primary" onClick={() => save({ analytics: true, advertising: true })}>Aceitar tudo</button>
        <button type="button" onClick={() => save({ analytics: false, advertising: false })}>Rejeitar tudo</button>
        <button type="button" className="cookie-actions__manage" aria-expanded={customizing} onClick={() => setCustomizing(!customizing)}>{customizing ? 'Ocultar preferências' : 'Gerenciar preferências'}</button>
        {customizing && <button type="button" onClick={() => save(choice)}>Salvar preferências</button>}
      </div>
    </section>}
    <footer className="cookie-preferences"><button type="button" onClick={() => { setCustomizing(true); setOpen(true) }}>Preferências de cookies</button></footer>
  </>
}
